module.exports = __webpack_public_path__ + "static/media/Step6.89dde63f.png";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/tutorial/Step6.png
// module id = 2241
// module chunks = 0